import { PortfolioAbout, PortfolioHome, PortfolioProjects } from '@/components/portfolio';
import React from 'react';

// IDE-specific portfolio components
export const PortfolioHomeIDE: React.FC = () => {
    return <PortfolioHome isMobile={false} />;
};

export const PortfolioAboutIDE: React.FC = () => {
    return <PortfolioAbout isMobile={false} />;
};

export const PortfolioProjectsIDE: React.FC = () => {
    return <PortfolioProjects isMobile={false} />;
};
